import * as yup from "yup";

const phoneRegExp =
  /^(?:(\+)?1)?\s?(\([2-9][0-8][0-9]\)|[2-9][0-8][0-9])[- ]?([2-9](?:1(?!1)|[02-9])[0-9])[- ]?[0-9]{4}$/;

export const phoneValidationSchema = yup
  .string()
  .transform((value) => (value === "" ? undefined : value))
  .matches(phoneRegExp, "Phone number is not valid");
